import * as React from 'react'
import { FC } from 'react'
import { Data, HoverSector } from './pie_chart'

type Props = {
  center: number
  data: Data
  radius: number
  strokeColor?: string
  strokeWidth?: number
  onSectorHover?: HoverSector
}

const Circle: FC<Props> = ({ center, data, radius, strokeColor = '#fff', strokeWidth = 1, onSectorHover }) => (
  <ellipse
    cx={center}
    cy={center}
    fill={data.color}
    rx={radius}
    ry={radius}
    stroke={strokeColor}
    strokeWidth={strokeWidth}
    onMouseEnter={e => onSectorHover(e, data, 0)}
    onMouseLeave={e => onSectorHover(e, null, null)}
  />
)

export default Circle
